/**
 * localStorage utility for persisting user preferences
 *
 * Provides type-safe methods for storing and retrieving user selections
 * across page reloads while respecting URL parameters as the source of truth.
 */

const STORAGE_PREFIX = "devpulse_"

export const StorageKeys = {
  VIEW: `${STORAGE_PREFIX}view`,
  TIME_RANGE: `${STORAGE_PREFIX}timeRange`,
  ACTIVE_TAB: `${STORAGE_PREFIX}activeTab`,
  SELECTED_TEAM: `${STORAGE_PREFIX}selectedTeam`,
  SELECTED_CONTRIBUTOR: `${STORAGE_PREFIX}selectedContributor`,
  CONTRIBUTORS_TIME_RANGE: `${STORAGE_PREFIX}contributorsTimeRange`,
  TEAMS_TIME_RANGE: `${STORAGE_PREFIX}teamsTimeRange`,
} as const

/**
 * Save a value to localStorage
 */
export function saveToStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch (error) {
    console.warn(`Failed to save to localStorage: ${key}`, error)
  }
}

/**
 * Get a value from localStorage
 */
export function getFromStorage(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    console.warn(`Failed to read from localStorage: ${key}`, error)
    return null
  }
}

/**
 * Remove a value from localStorage
 */
export function removeFromStorage(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.warn(`Failed to remove from localStorage: ${key}`, error)
  }
}

/**
 * Clear all DevPulse-related storage
 */
export function clearAllStorage(): void {
  try {
    Object.values(StorageKeys).forEach((key) => {
      localStorage.removeItem(key)
    })
  } catch (error) {
    console.warn("Failed to clear localStorage", error)
  }
}
